interface IServicesConstants {
    API_URL: string
}

const constants = <IServicesConstants>{
    API_URL: process.env.NEXT_PUBLIC_API_URL || 'https://api.n.exchange/en/api/v1',
}

const timeConstant = {
    MINUTE: 60,
    HOUR: 60 * 60,
    DAY: 24 * 60 * 60,
    WEEK: 7 * 24 * 60 * 60,
}

export type { IServicesConstants }
export default constants
export { timeConstant }
